import { api } from './client';
import type { Person, PersonType } from '../types/people';
import type { Task } from '../types/project';

export function fetchPeople(type?: PersonType): Promise<Person[]> {
  const path = type ? `/api/people?type=${encodeURIComponent(type)}` : '/api/people';
  return api.get<Person[]>(path);
}

export function createPerson(data: {
  name: string;
  email?: string | null;
  avatar_url?: string | null;
  person_type: PersonType;
}): Promise<Person> {
  return api.post<Person>('/api/people', data);
}

export function fetchPerson(id: string): Promise<Person> {
  return api.get<Person>(`/api/people/${id}`);
}

export function updatePerson(
  id: string,
  data: Partial<{ name: string; avatar_url: string | null; email: string | null; order_index: number; person_type: PersonType }>
): Promise<{ ok: boolean }> {
  return api.patch<{ ok: boolean }>(`/api/people/${id}`, data);
}

export function fetchTasksForPerson(personId: string): Promise<Task[]> {
  return api.get<Task[]>(`/api/people/${personId}/tasks`);
}
